import { BlockModule } from '@/website/blocks/common'
import { useElementVisibility } from '@vueuse/core'
import { watch } from 'vue'

new BlockModule({
    selector: '.block-blobs',
    setupBlock(el, onTeardown, context) {
        const animateEl = el.querySelector('.blob-animate')

        const isVisible = useElementVisibility(el as HTMLElement)

        watch(isVisible, (newVal) => {
            if (newVal) {
                animateEl?.classList.remove('blob-animate-paused')
            } else {
                animateEl?.classList.add('blob-animate-paused')
            }
        })
    },
})
